import React from 'react';
import { CardsSkeleton } from 'components/cards/listing/CardsSkeleton';
import { SpacingBlock } from 'components/spacing-block';


const LoadingSkeleton: React.FC = () => (
  <SpacingBlock mTop={5}>
    <CardsSkeleton />
  </SpacingBlock>
);

export default LoadingSkeleton;
